'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RemoteUserManager = require('./RemoteUserManager');

var _RemoteUserManager2 = _interopRequireDefault(_RemoteUserManager);

var _SocketChannelManager = require('./SocketChannelManager');

var _SocketChannelManager2 = _interopRequireDefault(_SocketChannelManager);

var _StaleBoardManager = require('./StaleBoardManager');

var _StaleBoardManager2 = _interopRequireDefault(_StaleBoardManager);

var _UserActivityManager = require('./UserActivityManager');

var _UserActivityManager2 = _interopRequireDefault(_UserActivityManager);

var _RefreshStaleBoardManager = require('./RefreshStaleBoardManager');

var _RefreshStaleBoardManager2 = _interopRequireDefault(_RefreshStaleBoardManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


var CollaborationManager = function (_React$Component) {
    _inherits(CollaborationManager, _React$Component);

    function CollaborationManager() {
        _classCallCheck(this, CollaborationManager);

        return _possibleConstructorReturn(this, (CollaborationManager.__proto__ || Object.getPrototypeOf(CollaborationManager)).apply(this, arguments));
    }

    _createClass(CollaborationManager, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                currentBoardId = _props.currentBoardId;

            return _react2.default.createElement(
                _RefreshStaleBoardManager2.default,
                { currentBoardId: currentBoardId },
                _react2.default.createElement(
                    _StaleBoardManager2.default,
                    { currentBoardId: currentBoardId },
                    _react2.default.createElement(
                        _SocketChannelManager2.default,
                        { currentBoardId: currentBoardId },
                        _react2.default.createElement(
                            _UserActivityManager2.default,
                            { currentBoardId: currentBoardId },
                            _react2.default.createElement(
                                _RemoteUserManager2.default,
                                { currentBoardId: currentBoardId },
                                children
                            )
                        )
                    )
                )
            );
        }
    }]);

    return CollaborationManager;
}(_react2.default.Component);

CollaborationManager.propTypes = {
    children: _propTypes2.default.element.isRequired,
    currentBoardId: _propTypes2.default.string
};

exports.default = CollaborationManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/collaboration/CollaborationManager.js
// module id = 2114
// module chunks = 0